module.exports = __webpack_public_path__ + "static/media/termsAndConditions.7fc38f09.pdf";